var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#AEB4BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61963 9.09499C7.23877 8.73007 7.23877 8.13853 7.61963 7.77361C8.00061 7.4088 8.61818 7.4088 8.99916 7.77361L12.0007 10.6486L15.0021 7.77361C15.3831 7.4088 16.0007 7.4088 16.3817 7.77361C16.7625 8.13853 16.7625 8.73007 16.3817 9.09499L13.1871 12.1549C13.1874 12.1665 13.1874 12.1781 13.1871 12.1897L16.3817 15.2496C16.7514 15.6163 16.7461 16.1992 16.3698 16.5596C15.9935 16.9201 15.385 16.9252 15.0021 16.571L12.0007 13.696L8.99916 16.571C8.61635 16.9252 8.00785 16.9201 7.63152 16.5596C7.25519 16.1992 7.2499 15.6163 7.61963 15.2496L10.8142 12.1897C10.8139 12.1781 10.8139 12.1665 10.8142 12.1549L7.61963 9.09499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8ebfba9d7b42390c00abb4ca01cfd008.svg";
export { ForwardRef as ReactComponent };